import { ComponentAnalytics } from '@gs-ux-uitoolkit-react/analytics';
import { Version } from './version';
export const componentAnalytics = new ComponentAnalytics({
    packageName: Version.name,
    version: Version.version,
});
componentAnalytics.trackPackageLoad();
